<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>系统用户</el-breadcrumb-item>
          <el-breadcrumb-item>管理日志</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            <el-button-group> </el-button-group>
          </div>
          <div class="r-list" style="margin-left: -15px">
            <div class="option">
              <cn-select-search
                v-model="companyId"
                :v_disabled="disabled"
                :v_whole="true"
                :data="companyList"
                @val="setCompanyId"
                placeholder="请筛选客户..."
              >
              </cn-select-search>

              <el-date-picker
                style="width: 280px"
                v-model="dateRange"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
              >
              </el-date-picker>
            </div>
            <div class="search-box">
              <el-input
                placeholder="输入关健字"
                v-model="keyword"
                v-show="false"
              >
              </el-input>
              <el-button
                type="primary"
                slot="append"
                icon="el-icon-search"
                @click="initData"
                style="float: right"
              ></el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="客户名称">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.companyName }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column prop="username" label="用户名"></el-table-column>
            <el-table-column prop="method" label="操作">
              <template slot-scope="scope">
                {{ scope.row.operation }}
              </template>
            </el-table-column>
            <el-table-column
              prop="ip"
              fixed="right"
              label="IP地址"
            ></el-table-column>
            <el-table-column
              prop="gmtCreate"
              fixed="right"
              label="操作时间"
            ></el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
import "../../js/select.component.js";
export default {
  data() {
    return {
      disabled: false,
      companyId: "",
      dateRange: [],
      companyList: [],
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
    };
  },
  mounted() {},
  methods: {
    //初始化工具栏
    initLoad: function () {
      let _this = this;

      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.disabled = true;
        _this.companyId = window.localStorage.getItem("fx_login_companyId");
      }

      // if(window.localStorage.getItem('fx_login_companyType')=="1")
      // {
      // 	_this.disabled=true;
      // 	_this.companyId = window.localStorage.getItem('fx_login_companyId');
      // 	var companyFullName = window.localStorage.getItem('fx_login_company');
      // 	_this.companyList.push({"companyFullName":companyFullName,"id":_this.companyId});

      // }
      // else{
      // 	//加载公司列表
      //    AxiosAjax({
      //        url: '/cabinet/company/search?index=1&size=9000',
      //        loading: true,
      //        success: function (res) {
      //            //console.log(res.data)
      //            _this.companyList = res.data.data;
      //        }
      //    });
      // }
    },
    //加载数据
    initData: function () {
      let _this = this;
      let sendUrl = "/cabinet/log/page";
      sendUrl += "?size=" + _this.pageSize;
      sendUrl += "&index=" + _this.pageIndex;

      if (_this.companyId.length > 0 && _this.companyId != 0) {
        sendUrl += "&companyId=" + _this.companyId;
      }

      if (_this.dateRange.length > 0) {
        sendUrl += "&gmtCreateFrom=" + _this.dateRange[0] + " 00:00:00";
        sendUrl += "&gmtCreateTo=" + _this.dateRange[1] + " 23:59:59";
      }

      AxiosAjax({
        url: sendUrl,
        beforeSend: function () {
          _this.loading = true;
        },
        success: function (res) {
          _this.listData = res.data.data.content;
          _this.totalCount = res.data.data.total;
          //_this.pageSize = res.data.data.size;
          _this.pageIndex = res.data.data.index;
          //console.log(pageInfo.totalCount);
        },
        error: function (err) {
          _this.listData = null;
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
    },
  },
  created: function () {
    //加载数据
    this.initLoad();
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Manager/ManagerLog.vue